module.exports = __webpack_public_path__ + "static/media/guia de ensino.650075b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/guia de ensino.pdf
// module id = 901
// module chunks = 2 7 38